import { tns } from 'tiny-slider/src/tiny-slider'

// Block slider
export function initBlockSlider (name, parent) {

	let slider;

	if (name && parent) {
		const element = parent.querySelector('[data-slider="' + name + '"]')
		const prev = parent.querySelector('[data-slider-prev="' + name + '"]')
		const next = parent.querySelector('[data-slider-next="' + name + '"]')

		// don't start function if the element is not on the page
		if (!element) return

		slider = tns({
			container: element,
			items: 1,
			slideBy: 1,
			mouseDrag: true,
			autoplay: true,
			autoplayTimeout: 2000,
			controls: true,
			nav: false,
			autoplayButtonOutput: false,
			prevButton: prev,
			nextButton: next,
			gutter: 0,
			loop: false,
			edgePadding: 0,
			responsive: {
				0: {
					items: 1,
				},
				992: {
					items: 1,
				}
			}
		})
	} else {
		console.log('missing Name or Container parameter')
		return 'missing Name or Container parameter'
	}

	return slider
}
